// Libs and configs
import API from "libs/API";
import { apiConfig, appConfig } from "configs";

//Action creators
import {
  setAppointment,
  setWebConfig,
  setAppPromptClose,
  setLanguageSelection,
  setFirebaseRemoteConfigs,
  setDeleteAccRequest,
  setDoctors,
} from "./actionCreators";

export function apiCall(
  apiKey,
  body,
  params,
  type,
  jsonType = true,
  thirdParty = false
) {
  return (dispatch, getState) =>
    new Promise(async (resolve, reject) => {
      const {
        user: { authentication },
      } = getState();

      const api = apiConfig[apiKey];

      let baseUrl;
      type === "nodeApi"
        ? (baseUrl = appConfig.node_api_base_url)
        : type === "nestApi"
        ? (baseUrl = appConfig.nest_api_base_url)
        : (baseUrl = appConfig.api_base_url_v2);

      const endpointRaw = api?.endpoint ?? apiKey;
      const endpoint =
        typeof endpointRaw === "string" && endpointRaw.length
          ? endpointRaw.startsWith("/")
            ? endpointRaw
            : `/${endpointRaw}`
          : "/";
      const method = api?.method ?? "POST";
      const escapeToken = api?.escapeToken ?? false;

      const url = `${thirdParty ? "" : baseUrl}${endpoint}`;
      const token = !escapeToken ? authentication?.accessToken : null;

      API(url, method, body, params, jsonType, token, thirdParty)
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
}

export function getAPI(apiKey, params, type) {
  return (dispatch) =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await dispatch(apiCall(apiKey, null, params, type));
        if (res.data) return resolve(res.data);
        else return resolve(res);
      } catch (err) {
        return reject(err);
      }
    });
}

export function postAPI(apiKey, body, params, type) {
  return (dispatch) =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await dispatch(apiCall(apiKey, body, params, type));
        if (res.data) return resolve(res.data);
        else return resolve(res);
      } catch (err) {
        return reject(err);
      }
    });
}

export function formDataAPI(apiKey, body, params, type) {
  return (dispatch) =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await dispatch(
          apiCall(apiKey, body, params, type, false, false)
        );
        return resolve(res.data ?? res);
      } catch (err) {
        return reject(err);
      }
    });
}

export function deleteAPI(apiKey, params, type) {
  return (dispatch) =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await dispatch(apiCall(apiKey, null, params, type));
        return resolve(res.data);
      } catch (err) {
        return reject(err);
      }
    });
}

export function patchAPI(apiKey, body, params, type) {
  return (dispatch) =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await dispatch(apiCall(apiKey, body, params, type, true));
        if (res.data) return resolve(res.data);
        else return resolve(res);
      } catch (err) {
        return reject(err);
      }
    });
}

export function setDoctorsAction() {
  return (dispatch, getState) =>
    new Promise(async (resolve, reject) => {
      try {
        // Use Nest base URL by passing the type: "nestApi"
        const data = await dispatch(getAPI("healthWorkers", null, "nestApi"));

        // data is already res.data from the Nest response
        await dispatch(setDoctors(data));

        return resolve(data);
      } catch (err) {
        return reject(err);
      }
    });
}

export function setAppointmentAction(status) {
  return (dispatch) => dispatch(setAppointment(status));
}
export function setWebConfigAction(status) {
  return (dispatch) => dispatch(setWebConfig(status));
}
export function setAppPromptCloseAction(status) {
  return (dispatch) => dispatch(setAppPromptClose(status));
}
export function setLanguageSelectionAction(status) {
  return (dispatch) => dispatch(setLanguageSelection(status));
}
export function setFirebaseRemoteConfigsAction(status) {
  return (dispatch) => dispatch(setFirebaseRemoteConfigs(status));
}
export function setDeleteAccRequestAction(status) {
  return (dispatch) => dispatch(setDeleteAccRequest(status));
}
